import { UserNutritionList, UserNutritionDetails } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for user management in the admin section.
 * @returns {Array} An array containing the route objects for user management.
 */
export default function route() {
  return [
    {
      path: adminRouteMap.USER_NUTRITION.path,  // URL path for user management
      name: "User Nutrition Logs",  // Display name for the route
      key: adminRouteMap.USER_NUTRITION.path,  // Unique key for the route
      private: true,  // Requires authentication to access
      belongsToSidebar: true,  // Appears in the admin sidebar
      icon: adminRouteMap.USER_NUTRITION.icon,  // Icon associated with user management
      element: <UserNutritionList />,  // Component to render for user management route
    },
    {
      path: `${adminRouteMap.USER_NUTRITION_DETAILS.path}/:id`,  // URL path for user details with dynamic user ID
      name: "User Nutrition Details",  // Display name for the user details route
      key: `${adminRouteMap.USER_NUTRITION_DETAILS.path}/:id`,  // Unique key for the user details route
      private: true,  // Requires authentication to access
      element: <UserNutritionDetails />,  // Component to render for user details route
    },
  ];
}
